import React from 'react'
import humanFormat from 'human-format'
import { BigNumber, BigNumberish } from 'ethers'

import './AmountG.scss'
import { ArrowUp, ArrowDown, GraeberLogo } from 'src/assets/images'

interface IProps {
  value: BigNumberish
  arrow?: 'up' | 'down'
}

export function AmountG({ value, arrow }: IProps) {
  return (
    <div className="amount-g">
      <img className="amount-g-img" alt="g" src={GraeberLogo} />
      <p className="amount-g-text">
        {humanFormat(BigNumber.from(value).div(BigNumber.from(10).pow(12)).toNumber(), {
          decimals: 1,
        })}
      </p>
      {arrow && (
        <img className="amount-g-arrow" alt="arrow" src={arrow === 'up' ? ArrowUp : ArrowDown} />
      )}
    </div>
  )
}
